'use client';

import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/button';
import { Database } from 'lucide-react';
import { DataViewToggle, useDataView } from '@/components/data-view-toggle';
import { useHashDialog } from '@/hooks/use-hash-dialog';

import { SHELVES_HASH } from '../constants';
import { ShelvesStatCards } from './shelves-stat-cards';
import { ShelvesListing } from './shelves-listing';
import { ShelfAddDialog } from './shelf-add-dialog';

export function ShelvesPageContent() {
  const t = useTranslations('shelves');
  // Add dialog open-state lives in the URL hash (#create).
  const { open: addOpen, onOpenChange: toggleAdd } = useHashDialog(
    SHELVES_HASH.create
  );
  const [view, setView] = useDataView('shelves');

  return (
    <div className='space-y-6'>
      <div className='flex items-start justify-between gap-4'>
        <div>
          <h1 className='text-2xl font-bold'>{t('pageTitle')}</h1>
          <p className='text-muted-foreground mt-1 text-sm'>
            {t('pageDescription')}
          </p>
        </div>
        <div className='flex shrink-0 items-center gap-2'>
          <DataViewToggle
            value={view}
            onValueChange={setView}
            pageKey='shelves'
            views={['table', 'grid', 'compact']}
          />
          <Button onClick={() => toggleAdd(true)}>
            <Database className='me-2 h-4 w-4' />
            {t('addNew')}
          </Button>
        </div>
      </div>

      <ShelvesStatCards />

      <ShelvesListing view={view} />

      <ShelfAddDialog open={addOpen} onOpenChange={toggleAdd} />
    </div>
  );
}
